/** Имя файла из публичного URL (последний сегмент пути). */
export function fileLabelFromUrl(url: string): string {
  try {
    const seg = new URL(url).pathname.split('/').pop();
    return seg ? decodeURIComponent(seg) : url;
  } catch {
    return url.length > 48 ? `…${url.slice(-40)}` : url;
  }
}
